<template>
<div id="purchases">
  <h2>Purchase Reports</h2>

  <purchase-nav></purchase-nav>

  <p class="alert alert-warning text-center" role="alert">
    Purchase reports are currently generated from locally stored purchase data &ndash;
    not retrieved directly from merchants.
  </p>

  <div v-if="this.reports.start_at">
    <hr />

    <h4>
      Purchase Reports from {{ this.reports.start_at }} to {{ this.reports.end_at }}
    </h4>

    <div
      v-if="this.reports.count > 0"
    >
      <table
        class="table text-center"
      >
        <th>
          Purchase Count
        </th>
        <th>
          Gross
        </th>
        <th>
          Fee
        </th>
        <th>
          Net
        </th>
        <tr>
          <td>
            {{ reports.count }}
          </td>
          <td>
            ${{ reports.gross }}
          </td>
          <td>
            ${{ reports.fee }}
          </td>
          <td>
            ${{ reports.net }}
          </td>
        </tr>
      </table>

      <ol>
        <li
          v-for="purchase in reports.purchases"
          :key="purchase.id"
        >
          {{  purchase }}
        </li>
      </ol>
    </div>
    <p v-else>
      No Purchases Found
    </p>

    <hr />
  </div>

  <form
    :action="actionUrl"
    method="post"
    v-on:submit.prevent="submit"
  >
    <fieldset>
      <legend>Report Criteria</legend>

      <div class="form-group row">
        <div class="col">
          <div class="calendar">
            <label
              for="purchase_start_at"
            >
              Start Date
            </label>

            <input
              type="date"
              class="form-control"
              name="start_at"
              id="purchase_start_at"
              v-model="startAt"
              v-on:change="change"
            />
          </div>
        </div>

        <div class="col">
          <div class="calendar">
            <label
              for="purchase_end_at"
            >
              End Date
            </label>

            <input
              type="date"
              class="form-control"
              name="end_at"
              id="purchase_end_at"
              v-model="endAt"
              v-on:change="change"
            />
          </div>
        </div>
      </div>

      <p class="text-center">
        <strong>
          OR
        </strong>
      </p>

      <div class="form-group row">
        <div class="col-2">
          <label
            for="purchase_month"
          >
            By Month
          </label>
        </div>
        <div class="col-5">
          <select
            name="month"
            id="purchase_month"
            class="form-control"
            v-on:change="change"
          >
            <option value="January">JAN</option>
            <option
              value=""
            >
              Select Month
            </option>
            <option
              v-for="month in months"
              v-bind:value="month.value"
            >
              {{ month.name }}
            </option>
          </select>
        </div>

        <div class="col-5">
          <select
            name="year"
            id="purchase_year"
            class="form-control"
            v-on:change="change"
          >
          <option value="2024">Last Year</option>
            <option
              v-for="year in years"
              v-bind:value="year"
            >
              {{ year }}
            </option>
          </select>
        </div>
      </div>

    </fieldset>

    <button
      type="submit"
      class="btn btn-primary btn-block form-control"
    >
      <span>Get Reports</span>
      <vue-simple-spinner size="small" v-if="loading"></vue-simple-spinner>
    </button>
  </form>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import Spinner from 'vue-simple-spinner'

import PurchaseNav from '@/components/PurchaseNav'

import PurchaseStore from '@/stores/PurchaseStore'
// import PurchasesStore from '@/stores/PurchasesStore'

export default {
  components: {
    pagination: Pagination,
    'purchase-nav': PurchaseNav,
    'vue-simple-spinner': Spinner
  },

  data: function () {
    let state = PurchaseStore.state
    state.loading = false
    state.reports = {}
    state.month = ''
    state.year = undefined
    state.start_at = undefined
    state.end_at = undefined
    state.actionUrl = undefined

    return state
  },

  computed: {
    defaultMonth () {
      return new Date().getUTCMonth()
    },

    defaultYear () {
      return new Date().getUTCFullYear()
    },

    months () {
      return this.$root.months.map((month, i) => {
        return {
          name: month,
          value: (i + 1)
        }
      })
    },

    years () {
      const thisYear = this.defaultYear
      const startYear = 2012

      let ys = []
      for (let i = startYear; i <= thisYear; i++) {
        ys.push(i)
      }

      return ys
    },

    endAt () {
      const d = new Date(this.defaultYear, this.defaultMonth)

      return this.$root.dateFmt(d)
    },

    startAt () {
      const d = new Date(this.defaultYear, (this.defaultMonth - 1))
      return this.$root.dateFmt(d)
    }
  },

  methods: {
    change (ev) {
      const eid = ev.target.getAttribute('name')
      const undefMonth = ''

      // Reset month.
      if (eid !== 'month' && eid !== 'year') {
        this.month = undefMonth
      }

      if (this.month !== undefMonth) {
        this.actionUrl = this.apiUrl('/purchases/reports_by_month', true)
      } else {
        this.actionUrl = this.apiUrl('/purchases/reports_by_range', true)
      }
    },

    submit (ev) {
      this.loading = true

      this.bindSubmit(ev).then((resp) => {
        this.loading = false

        this.reports = this.processSuccess(resp)
      }, (resp) => {
        this.loading = false
        this.processErrors(resp)
      })
    }
  }
}
</script>

<style scoped>
th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseReports.vue